// extracted by mini-css-extract-plugin
export default {"explanation":"RepayEarly_explanation","explanationAmount":"RepayEarly_explanationAmount"};